import { render, staticRenderFns } from "./CollectionsView.vue?vue&type=template&id=014dcb41&"
import script from "./CollectionsView.vue?vue&type=script&lang=ts&"
export * from "./CollectionsView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VDivider,VSkeletonLoader})
